import { RadioGroupInput } from 'core/components';
import { InputType as JoyInputType } from 'core/enums';

import AsyncSelect from 'coreOld/components/AsyncSelect';
import CheckboxInput from 'coreOld/components/CheckboxInput';
import DateInput from 'coreOld/components/DateInput';
import PasswordInput from 'coreOld/components/PasswordInput';
import Select from 'coreOld/components/Select';
import TextEditor from 'coreOld/components/TextEditor';
import TextInput from 'coreOld/components/TextInput';
import ToggleSwitch from 'coreOld/components/ToggleSwitch';
import { InputType } from 'coreOld/enums';

interface IProps {
  type: InputType | JoyInputType;
  name: string;
  inputProps?: Record<string, any>;
}

const InputField = ({ type, inputProps, name }: IProps) => {
  switch (type) {
    case InputType.ASYNC_SELECT:
      return <AsyncSelect name={name} {...inputProps} />;
    case InputType.CHECKBOX:
      return <CheckboxInput name={name} {...inputProps} />;
    case InputType.DATE_INPUT:
      return <DateInput name={name} {...inputProps} />;
    case InputType.SELECT:
      return <Select name={name} {...inputProps} />;
    case InputType.PASSWORD:
      return <PasswordInput name={name} {...inputProps} />;
    case InputType.TEXTFIELD:
      return <TextInput name={name} {...inputProps} />;
    case InputType.TEXTEDITOR:
      return <TextEditor name={name} {...inputProps} />;
    case InputType.TOGGLE_SWITCH:
      return <ToggleSwitch name={name} {...inputProps} />;
    case JoyInputType.RADIO_GROUP:
      return <RadioGroupInput name={name} {...inputProps} />;
    default:
      throw new Error(`Unknown input type "${type}"`);
  }
};

export default InputField;
